/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import * as Yup from 'yup';

import EFormValidation from '@modules/form/const/formValidation';
import { ELocaleKeys } from '@modules/internationalization/intConstants';
import type { ICorporateFormTranslation } from '@modules/internationalization/types/corporate';
import { stringFormatParams } from '@utils/stringFormat';

import { ETemplateRenameField } from '../constants';

export const setTemplateRenameValidationSchema = (translation: ICorporateFormTranslation) => {
    const { validation } = translation;

    const nameLongError = stringFormatParams(validation[EFormValidation.fieldTemplateNameLong], {
        [ELocaleKeys.number]: 100,
    });

    const requiredField = validation[EFormValidation.fieldRequired];

    return Yup.object().shape({
        [ETemplateRenameField.name]: Yup.string().max(100, nameLongError).required(requiredField),
    });
};
